import { useEventStore } from './event-store.js'
import { onBeforeMount, onBeforeUnmount, watch } from 'vue'

export const EventProvider = {
  compatConfig: { COMPONENT_V_MODEL: false },
  props: {
    eventSid: {
      type: String
    },
    modelValue: {
      type: Object
    }
  },
  render () {
    return []
  },
  emits: ['update:modelValue'],
  setup (props, { emit }) {
    const events = useEventStore()

    onBeforeMount(() => {
      const event = events.get(props.eventSid)
      emit('update:modelValue', event.value)

      const stopWatch = watch(event, (val) => {
        emit('update:modelValue', val)
      })

      onBeforeUnmount(() => {
        stopWatch()
      })
    })

    return {}
  }
}
